<template>
  <div class="topbar">
    <!-- 工具栏按钮 -->
    <button @click="$emit('showLayerPanel')">
      <i class="fas fa-list"></i> 图层
    </button>  
    <button @click="$emit('resetPatches')">
      <i class="fas fa-times"></i> 清除选择
    </button>  
    <button @click="showCPContent">
      <i class="fas fa-globe"></i> 全览
    </button>     
    
    <button @click="$emit('showSelectButtons')">
      <i class="fas fa-filter"></i> 条件统计
    </button>
    <input type="text" v-model="searchKeyword" placeholder="输入图斑编号、图斑属性信息等">
    <button @click="search">
      <i class="fas fa-search"></i>
    </button>
    <button @click="$emit('toggleTableMenu')">
      <i class="fas fa-table"></i> 表格
    </button>   
    <label>统计依据：</label> 
    <select v-model="selectedLayer" @change="$emit('currLayerChange',selectedLayer)">
      <option v-for="(layer, index) in layers" :key="index" :value="layer.TCMC">
        {{ layer.statPatches ? `${layer.TCJC}(${layer.statPatches.length}个图斑)` : `${layer.TCJC}(全图斑)` }}
      </option>
    </select>
    <button @click="$emit('resetStatPatches')">
      <i class="fa-solid fa-undo"></i> 重置依据
    </button>
    <button @click="$emit('quickSelectByYN')">
      <i class="fas fa-exchange"></i> 快切永农
    </button>
    <label>申请：</label> 
    <button @click="$emit('toggleUpdateInfoMenu')">
      <i class="fas fa-hand-holding"></i> 我的申请
    </button>
    <button @click="$emit('toggleReportInfo')">
      <i class="fas fa-file-alt"></i> 报告
    </button>
    <button v-if="false" @click="$emit('test')">
      <i class="fas fa-hand-holding"></i> 测试按钮
    </button>
    <!-- <button v-if="role=='admin' || role == 'superadmin'" @click="$emit('')">
      <i class="fas fa-gavel"></i> 我的审核
    </button> -->
  </div>
</template>

<script>
export default {
  name: 'TopbarMenu',
  props:{
    layers:{
      type:Array,
      default:()=>[] 
    }
  },  
  mounted(){
    this.role = localStorage.getItem('role');
  },
  data() {
    return {      
      searchKeyword:"",
      selectedLayer:null,
      role:"normal",
    };
  },
   methods: {
    getPatchList() {     
      this.$emit("clickGetPatchList", "");      
    },
    showCPContent(){
        this.$emit("clickShowCPContent","");
    },    
    search(){     
      if(this.selectedLayer && this.searchKeyword.length > 0){
        this.$emit("searchPatch",{keyword:this.searchKeyword,TCMC:this.selectedLayer});
      }      
    },    
  }
}
</script>

<style scoped>
.topbar {
  position: fixed;
  top:5vh;
  left:200px;
  display: flex;
  background-color: #f4f4f4;
  padding: 5px;
  z-index: 1000;
  border: 1px solid #292541;
  align-items: stretch;
}

.topbar button {
  margin-right: 10px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
}

.topbar button i {
  margin-right: 5px;
}

/* 为下拉框添加一些样式 */
.topbar select {
  margin-right: 10px;
  padding: 5px;
}

.topbar label{
  margin-top: 3px;
  font-size: 14px;
}

</style>
